import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../styles/Head.css';
import GlobalSettings from './GlobalSettings.js';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import PageInvalid from './PageInvalid.js';
import { GlobalStateContext } from './GlobalStateContext.js';

const Info = () => {
    const {
        surveyCode,
        questionset_id,
        valid,
        surveyName,
        surveyTitle,
        answerSet,
        languageId, 
        completeSet,
        participationCode, 
        surveyMode, 
        token
    } = useContext(GlobalStateContext);

    const [state, setState] = useState({
        title: [],
        topic: [],
        bodytext1: [],
        bodytext2: [],
        bodytext3: [],
        resultsClosed: [],
        btnText: [],
        surveyCompleted:false
    });

    const navigate = useNavigate();

    useEffect(() => {
       /* fetch(`/api/title/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                title: result
            })))
            .catch(console.log);*/
            // check Survey-completion
                // survey already completed?
            /*     console.log("PartCode", participationCode);
                if(participationCode && participationCode.length>1){
                    const surveyCompletedResult = fetch('/surveyDoneInfo/' + participationCode);
                    console.log("Info:SuCo", surveyCompletedResult);
                    const surveyCompletedData = surveyCompletedResult;
                    setState(prevState => ({
                        ...prevState,
                        surveyCompleted: surveyCompletedData
                    }))
                }
                else {
                    setState(prevState => ({
                        ...prevState,
                        surveyCompleted: 0
                    }))
                } */


            if(participationCode && participationCode.length>1){
                fetch('/api/surveyDoneInfo/' + participationCode)
                .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                surveyCompleted: result
            })))
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    surveyCompleted: 0
                }))
            } 
            
            fetch(`/api/infobtnText/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                btnText: result
            })))
            .catch(console.log);

            fetch(`/api/resultsClosed/${completeSet[0].QuestionSet_ID}/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                resultsClosed: result
            })))
            .catch(console.log);
    }, [languageId, questionset_id]);

    const nextPath = (path) => {
        navigate(path);
    };

    

    if ((token !== "true" || state.surveyCompleted) && (!surveyMode)) {
        return (
            <div>
                <PageHeader />
                <PageInvalid />
                <PageFooter />
            </div>
        );
    } else {
        return (
            <div>
                <div>
                    <PageHeader headerText={surveyTitle} surveyName={surveyName} mode={surveyMode}/>
                </div>
                <div className="questionBody">
                    <div className="bubbleInactive"></div>
                    <div className="bubbleActive">
                        <div className="bubbleTextContent">
                            {state.resultsClosed[0]?.questionset_text}
                            <br /><br />
                            {state.bodytext2[0]?.substring}<br /><br />
                            {state.bodytext3[0]?.substring}
                        </div>
                        <div className="bubbleFooter">
                            <div className="bubbleStart">
                                <Link to="/Overview">
                                    <button className="btnBubble">{state.btnText[0]?.text}</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="bubbleInactive"></div>
                </div>
                <PageFooter progress={100} />
            </div>
        );
    }
};

export default Info;
